import { t, Instance } from 'mobx-state-tree';
import type { PersonFactResponse } from 'we-tree-api-client/v2';

/**
 * PersonFactModel - Represents a person fact
 */
export const PersonFactModel = t
  .model('PersonFactModel', {
    id: t.string,
    familyMemberId: t.string,
    factTypeId: t.string,
    detail: t.maybeNull(t.string),
    notes: t.maybeNull(t.string),
    sourceNotes: t.maybeNull(t.string),
    createdAt: t.string,
    updatedAt: t.string,
    createdByNickname: t.maybeNull(t.string),
    updatedByNickname: t.maybeNull(t.string)
  })
  .views(() => ({
    // Add any computed views if needed
  }));

export type PersonFactType = Instance<typeof PersonFactModel>;

/**
 * Helper function to create PersonFactModel from API response
 */
export function createPersonFactModelFromResponse(response: PersonFactResponse): Instance<typeof PersonFactModel> {
  return PersonFactModel.create({
    id: response.id,
    familyMemberId: response.familyMemberId,
    factTypeId: response.factTypeId,
    detail: response.detail ?? null,
    notes: response.notes ?? null,
    sourceNotes: response.sourceNotes ?? null,
    createdAt: response.createdAt || new Date().toISOString(),
    updatedAt: response.updatedAt || new Date().toISOString(),
    createdByNickname: (response as { createdByNickname?: string | null }).createdByNickname ?? null,
    updatedByNickname: (response as { updatedByNickname?: string | null }).updatedByNickname ?? null
  });
}
